import { combineReducers } from 'redux';

import alertNotificationsReducer from './alertNotificationsReducer';

export default combineReducers({
  // TODO: add services and toasts reducer.
  alertNotifications: alertNotificationsReducer
});
